// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"30a35db666db8e4e7fe2","293":"a0add49039517d597e4a"}[chunkId] + ".js";
};